import { render, staticRenderFns } from "./TabbedView.vue?vue&type=template&id=d64b3af4"
import script from "./TabbedView.vue?vue&type=script&lang=js"
export * from "./TabbedView.vue?vue&type=script&lang=js"
import style0 from "./TabbedView.vue?vue&type=style&index=0&id=d64b3af4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports